import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";
import { Mail, Shield, Calendar, BadgeCheck } from "lucide-react";

export default function Profile() {
  const { user } = useAuth();
  if (!user || user === false) return null;

  const subBadge = user.subscription_status === "active"
    ? "bg-green-500/10 text-green-400 border-green-500/30"
    : user.subscription_status === "cancelled"
    ? "bg-yellow-500/10 text-yellow-400 border-yellow-500/30"
    : "bg-white/5 text-white/50 border-white/10";

  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-12 py-12" data-testid="profile-page">
      <p className="text-eyebrow">Account</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black mt-2 tracking-tighter">{user.name}</h1>

      <div className="mt-8 card-surface p-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div>
            <p className="text-eyebrow mb-2 flex items-center gap-2"><Mail className="h-3 w-3" /> Email</p>
            <p className="font-display font-bold" data-testid="profile-email">{user.email}</p>
          </div>
          <div>
            <p className="text-eyebrow mb-2 flex items-center gap-2"><Shield className="h-3 w-3" /> Role</p>
            <p className="font-display font-bold capitalize" data-testid="profile-role">{user.role}</p>
          </div>
          <div>
            <p className="text-eyebrow mb-2 flex items-center gap-2"><BadgeCheck className="h-3 w-3" /> Subscription</p>
            <span className={`badge-pill border ${subBadge}`} data-testid="profile-subscription">{user.subscription_status}</span>
          </div>
          <div>
            <p className="text-eyebrow mb-2 flex items-center gap-2"><Calendar className="h-3 w-3" /> Member since</p>
            <p className="font-display font-bold">{user.created_at ? new Date(user.created_at).toLocaleDateString() : "—"}</p>
          </div>
        </div>
      </div>

      <div className="mt-6 flex flex-wrap gap-3">
        <Link to="/subscription" className="ember-btn" data-testid="profile-manage-sub">Manage subscription</Link>
        {user.role === "creator" && <Link to="/creator" className="ghost-btn">Creator Studio</Link>}
        {user.role === "admin" && <Link to="/admin" className="ghost-btn">Admin Panel</Link>}
      </div>
    </div>
  );
}
